import rpc from "@/rpc";

class FunctionsService {
    rpc

    constructor(rpc) {
        this.rpc = rpc
    }

    getBorrower(uuid) {
        return this.rpc.execute('getBorrower', {
            uuid: uuid
        })
    }

    getApplication(uuid) {
        return this.rpc.execute('getApplication', {
            uuid
        });
    }

    deleteEvent(uuids, code, actions = [], bureaus = [], sendStop = true) {
        return this.rpc.execute('deleteEvent', {
            identifiers: Array.isArray(uuids) ? uuids : [String(uuids).trim()],
            actions,
            code,
            bureaus,
            sendStop
        })
    }

    exportFiles(identifiers, splitEventsByFolders, exportAsSingleFile, email) {
        return this.rpc.execute('exportFiles', {
            identifiers,
            splitEventsByFolders,
            exportAsSingleFile,
            email,
        })
    }

    getAudit(uuids, type, email, needFiles = false, splitEventsByFolders = false, exportAsSingleFile = false) {
        return this.rpc.execute('createAuditReport', {
            cbUuid: Array.isArray(uuids) ? uuids : [String(uuids).trim()],
            type: type,
            email: email,
            needFiles: needFiles,
            splitEventsByFolders: splitEventsByFolders,
            exportAsSingleFile: exportAsSingleFile
        })
    }
}

export default new FunctionsService(rpc)